import { PartnerProfileManagementTable } from "../PartnerProfileManagementTable";
import { Button, Checkbox, DataSource, HorizontalSpacer, Layout, SearchPanel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPartnerProfileManagement extends Layout {
    buttonAddProfile: Button;
    buttonCollapse: Button;
    buttonDownloadSnap: Button;
    buttonExpand: Button;
    buttonImportSnap: Button;
    checkboxIntercompany: Checkbox;
    horizontalspacer2: HorizontalSpacer;
    layoutGenericInbound: PartnerProfileManagementTable;
    layoutInvoiceInbound: PartnerProfileManagementTable;
    layoutInvoiceOutbound: PartnerProfileManagementTable;
    layoutRemittanceInbound: PartnerProfileManagementTable;
    layoutStatusInbound: PartnerProfileManagementTable;
    layoutStatusOutbound: PartnerProfileManagementTable;
    layoutTenderInbound: PartnerProfileManagementTable;
    layoutTenderOutbound: PartnerProfileManagementTable;
    searchpanelProfileManagement: SearchPanel;
    sourcePartnerProfileManagement: DataSource;
    tabGenericInbound: Tab;
    tabInvoiceInbound: Tab;
    tabInvoiceOutbound: Tab;
    tabRemitInbound: Tab;
    tabStatusInbound: Tab;
    tabStatusOutbound: Tab;
    tabTenderInbound: Tab;
    tabTenderOutbound: Tab;
    tabset1: Tabset;
    textboxAltPartnerId: Textbox;
    textboxCarrierId: Textbox;
    textboxCustomerId: Textbox;
    textboxDirection: Textbox;
    textboxEdiCommId: Textbox;
    textboxNextBatch: Textbox;
    textboxPartnerId: Textbox;
    textboxPartnerName: Textbox;
    textboxPartnerStatus: Textbox;
    textboxProcessPriority: Textbox;
    textboxProfileType: Textbox;
    textboxTemplateId: Textbox;
    textboxTransactionSet: Textbox;
    textboxVersion: Textbox;
}
